var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnomalySunburstEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 6a94 94 0 0160.42 21.99l-20.57 24.52A62 62 0 00100 38z",
    fill: "#dfe6ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.42 27.99a94 94 0 0129.94 46.1l-30.76 8.82a62 62 0 00-19.75-30.4z",
    fill: "#eaeef3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.36 74.09a94 94 0 01-8.95 72.91l-27.72-16a62 62 0 005.91-48.09z",
    fill: "#d6dee7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.41 147A94 94 0 01147 181.41l-16-27.72A62 62 0 00153.69 131z",
    fill: "#cfe0f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147 181.41a94 94 0 01-72.91 8.95l8.82-30.76a62 62 0 0048.09-5.91z",
    fill: "#e8edf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.09 190.36a94 94 0 01-53.81-40.55l27.14-16.96a62 62 0 0035.49 26.75z",
    fill: "#dbe3ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.28 149.81A94 94 0 019.64 74.09l30.76 8.82a62 62 0 007.02 49.94z",
    fill: "#eef2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64 74.09a94 94 0 0132.49-48.16l19.7 25.21A62 62 0 0040.4 82.91z",
    fill: "#d9e1ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.13 25.93A94 94 0 01100 6v32a62 62 0 00-38.17 13.14z",
    fill: "#e6ebf1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 42a58 58 0 0157.68 51.94l-27.84 2.92A30 30 0 00100 70z",
    fill: "#e9edf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.68 93.94A58 58 0 01129 150.23l-14-24.25a30 30 0 0014.84-29.12z",
    fill: "#dde5ee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 150.23a58 58 0 01-74.7-14.52l22.06-17.24a30 30 0 0038.64 7.51z",
    fill: "#eef2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3 135.71A58 58 0 0149.77 71l24.25 14a30 30 0 002.34 33.47z",
    fill: "#e0e7ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.77 71A58 58 0 01100 42v28a30 30 0 00-25.98 15z",
    fill: "#e9edf2"
  }))));
}
export default SvgAnomalySunburstEmptyState;